var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLunchTableGridIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 52,
    viewBox: "0 0 75 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 52,
    fill: "#F2F4F7",
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2425_44264",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 75,
    height: 52
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 74,
    height: 51,
    fill: "#A6AEBA",
    stroke: "#767F8D"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2425_44264)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 114.356,
    y2: -0.5,
    transform: "matrix(0.763545 0.645755 -0.90746 0.420139 -66.9883 23.6702)",
    stroke: "#303742",
    strokeOpacity: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 114.356,
    y2: -0.5,
    transform: "matrix(0.763545 0.645755 -0.90746 0.420139 -37.4951 10.729)",
    stroke: "#303742",
    strokeOpacity: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 114.356,
    y2: -0.5,
    transform: "matrix(0.763545 0.645755 -0.90746 0.420139 -8.00195 -2.21411)",
    stroke: "#303742",
    strokeOpacity: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 114.356,
    y2: -0.5,
    transform: "matrix(0.763545 0.645755 -0.90746 0.420139 21.4912 -15.1542)",
    stroke: "#303742",
    strokeOpacity: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 114.356,
    y2: -0.5,
    transform: "matrix(0.763545 0.645755 -0.90746 0.420139 50.9844 -28.0964)",
    stroke: "#303742",
    strokeOpacity: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 114.356,
    y2: -0.5,
    transform: "matrix(0.763545 0.645755 -0.90746 0.420139 -59.6152 20.4336)",
    stroke: "#303742",
    strokeOpacity: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 114.356,
    y2: -0.5,
    transform: "matrix(0.763545 0.645755 -0.90746 0.420139 -30.123 7.49365)",
    stroke: "#303742",
    strokeOpacity: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 114.356,
    y2: -0.5,
    transform: "matrix(0.763545 0.645755 -0.90746 0.420139 -0.629883 -5.44861)",
    stroke: "#303742",
    strokeOpacity: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 114.356,
    y2: -0.5,
    transform: "matrix(0.763545 0.645755 -0.90746 0.420139 28.8643 -18.3898)",
    stroke: "#303742",
    strokeOpacity: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 114.356,
    y2: -0.5,
    transform: "matrix(0.763545 0.645755 -0.90746 0.420139 58.3574 -31.3319)",
    stroke: "#303742",
    strokeOpacity: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 114.356,
    y2: -0.5,
    transform: "matrix(0.763545 0.645755 -0.90746 0.420139 -52.2422 17.198)",
    stroke: "#303742",
    strokeOpacity: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 114.356,
    y2: -0.5,
    transform: "matrix(0.763545 0.645755 -0.90746 0.420139 -22.749 4.25806)",
    stroke: "#303742",
    strokeOpacity: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 114.356,
    y2: -0.5,
    transform: "matrix(0.763545 0.645755 -0.90746 0.420139 6.74414 -8.6842)",
    stroke: "#303742",
    strokeOpacity: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 114.356,
    y2: -0.5,
    transform: "matrix(0.763545 0.645755 -0.90746 0.420139 36.2373 -21.6262)",
    stroke: "#303742",
    strokeOpacity: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 114.356,
    y2: -0.5,
    transform: "matrix(0.763545 0.645755 -0.90746 0.420139 65.7295 -34.5663)",
    stroke: "#303742",
    strokeOpacity: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 114.356,
    y2: -0.5,
    transform: "matrix(0.763545 0.645755 -0.90746 0.420139 -44.8691 13.9634)",
    stroke: "#303742",
    strokeOpacity: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 114.356,
    y2: -0.5,
    transform: "matrix(0.763545 0.645755 -0.90746 0.420139 -15.376 1.02136)",
    stroke: "#303742",
    strokeOpacity: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 114.356,
    y2: -0.5,
    transform: "matrix(0.763545 0.645755 -0.90746 0.420139 14.1172 -11.9197)",
    stroke: "#303742",
    strokeOpacity: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 114.356,
    y2: -0.5,
    transform: "matrix(0.763545 0.645755 -0.90746 0.420139 43.6104 -24.8629)",
    stroke: "#303742",
    strokeOpacity: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 114.356,
    y2: -0.5,
    transform: "matrix(0.763545 0.645755 -0.90746 0.420139 73.1035 -37.8029)",
    stroke: "#303742",
    strokeOpacity: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLunchTableGridIcon);
export default __webpack_public_path__ + "static/media/LunchTableGridIcon.808a0aaf79ed0fa66372c2e67ba46915.svg";
export { ForwardRef as ReactComponent };